<template>
  <div class="right-menu" :class="{'right-menu-bg':isBg}">
    <template v-if="device !== 'mobile'">
      <search id="header-search" class="right-menu-item" />
      <badge id="message-badge" class="right-menu-item" />
      <!-- <error-log class="errLog-container right-menu-item hover-effect" /> -->

      <screenfull id="screenfull" class="right-menu-item hover-effect" />

      <el-tooltip content="Global Size" effect="dark" placement="bottom">
        <size-select id="size-select" class="right-menu-item hover-effect" />
      </el-tooltip>
      <div v-if="showSettings" class="right-menu-item hover-effect">
        <svg-icon icon-class="more" class="more-panel" @click="showPanel" />
        <right-panel ref="rightPanel">
          <settings />
        </right-panel>
      </div>

      <div>
        <el-tag size="mini" effect="dark" :type="user.type==='corp'?'':'danger'">{{ user.type==='corp'? '管理端':'运营端' }}</el-tag>
      </div>

    </template>
    <el-dropdown
      class="avatar-container right-menu-item hover-effect"
      trigger="click"
    >
      <div class="avatar-wrapper">
        <img :src="avatar + '?imageView2/1/w/80/h/80'" class="user-avatar">
        <i class="el-icon-caret-bottom" />
      </div>
      <el-dropdown-menu slot="dropdown">
        <router-link to="/profile/index">
          <el-dropdown-item>个人信息</el-dropdown-item>
        </router-link>
        <el-dropdown-item divided @click.native="clearCache">
          <span style="display: block">清除缓存</span>
        </el-dropdown-item>
        <el-dropdown-item divided @click.native="logout">
          <span style="display: block">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { clearCache } from '@/api/system'

import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import SizeSelect from '@/components/SizeSelect'
import Search from '@/components/HeaderSearch'
import Badge from '@/components/Message/badge'
import RightPanel from '@/components/RightPanel'
import Settings from './Settings'

export default {
  components: {
    ErrorLog,
    SizeSelect,
    RightPanel,
    Settings,
    Screenfull,
    Search,
    Badge
  },
  props: {
    isBg: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device',
      'showSettings',
      'sidebarView',
      'user'
    ])
  },
  methods: {
    async clearCache() {
      await clearCache()
      this.$message({
        message: '系统缓存清理完成',
        type: 'success'
      })
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      const code = this.$store.state.user.code
      await this.$store.dispatch('user/logout')
      if (code) {
        this.$router.push(`/project/${code}/login`)
      } else {
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      }
    },
    showPanel() {
      this.$refs.rightPanel.show = true
    }
  }
}
</script>

<style scoped lang="scss">
.right-menu {
  height: 100%;
  line-height: 50px;
  display: flex;

  float: right;

  &::before {
    content: "";
    display: table;
  }

  &::after {
    clear: both;
    *zoom: 1;
  }

  &:focus {
    outline: none;
  }

  .right-menu-item {
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }

    .more-panel {
      font-size: 24px;
    }
  }

  .avatar-container {
    width: 60px;
    margin-right: 30px;

    .avatar-wrapper {
      margin-top: 5px;
      position: relative;

      .user-avatar {
        cursor: pointer;
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }

      .el-icon-caret-bottom {
        cursor: pointer;
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}

.right-menu-bg {
  background-color: #2b2f3a;
}
</style>
